function getParameters(url, params) {
    const res = {};
    try {
        const searchParams = new URL(url).searchParams;
        for (let i = 0; i < params.length; i++) {
            const param = params[i];
            res[param] = searchParams.get(param) || '';
        }
    } catch (e) {
        console.error('Url parsing failed:', url);
    }
    return res;
}

module.exports = {
    getParameters: getParameters
};
